var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPico8Logo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#ffffff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "m204.2871094 0v101.8828125l-102.1425781.26171875-.26171875 102.1425781h-101.8828125v103.4257812h101.8886719v102.3984375h102.3984375v101.8886719h103.4257812v-101.8886719h102.3984375v-102.3984375h101.8886719v-103.4257812h-101.8886719v-102.3984375h-102.3984375v-101.8886719h-103.4257812zm1.02539063 102.9121094h101.375v102.4003906h102.4003906v101.3710938l-102.1445312.25976563-.25976563 102.1445312h-101.3710938v-102.4003906h-102.4003906v-101.375h102.4003906v-102.4003906z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPico8Logo);
export default __webpack_public_path__ + "static/media/pico8Logo.ce70fa2853142019208674117d716bef.svg";
export { ForwardRef as ReactComponent };